(() => {
  'use strict';
  const instances = new Map();
  const mount = (scope = document) => {
    const headers = [...scope.querySelectorAll('[data-editorial-header]')];
    if (scope.matches?.('[data-editorial-header]')) headers.unshift(scope);
    for (const header of headers) {
      if (instances.has(header)) continue;
      const section = header.closest('.lh-editorial-header-section');
      const toggle = header.querySelector('[data-editorial-menu-open]');
      const dialog = section?.querySelector('[data-editorial-menu]');
      if (!toggle || !dialog || typeof dialog.showModal !== 'function') continue;
      const controller = new AbortController();
      const listen = (target,type,handler,options={}) => target.addEventListener(type,handler,{...options,signal:controller.signal});
      const disclosures = [...dialog.querySelectorAll('details')];
      const home = header.hasAttribute('data-home-header');
      let frame = 0;
      const update = () => { frame = 0; if (home) header.classList.toggle('is-scrolled',scrollY > 48); };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const close = () => { if (dialog.open) dialog.close(); };
      listen(toggle,'click',() => {
        if (dialog.open) return;
        disclosures.forEach(item => { item.open = false; });
        dialog.showModal();
        toggle.setAttribute('aria-expanded','true');
        document.documentElement.setAttribute('data-lh-menu-open','');
        dialog.querySelector('[data-editorial-menu-close]')?.focus({preventScroll:true});
      });
      listen(dialog.querySelector('[data-editorial-menu-close]'),'click',close);
      listen(dialog,'keydown',event => { if (event.key === 'Escape') { event.preventDefault(); close(); } });
      listen(dialog,'close',() => {
        toggle.setAttribute('aria-expanded','false');
        document.documentElement.removeAttribute('data-lh-menu-open');
        if (toggle.isConnected) toggle.focus({preventScroll:true});
      });
      listen(dialog,'click',event => {
        if (event.target.closest('a')) { close(); return; }
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      });
      disclosures.forEach(item => listen(item,'toggle',() => { if (item.open) disclosures.forEach(other => { if (other !== item) other.open = false; }); }));
      if (home) { listen(window,'scroll',schedule,{passive:true}); listen(window,'pageshow',schedule); }
      update();
      instances.set(header,() => { close(); controller.abort(); cancelAnimationFrame(frame); });
    }
  };
  mount();
  document.addEventListener('shopify:section:load',event => mount(event.target));
  document.addEventListener('shopify:section:unload',event => {
    for (const [header,destroy] of instances) if (event.target.contains(header)) { destroy(); instances.delete(header); }
  });
})();
